import { Box } from "@mui/material";

import SwiggyLogo from "../../resources/swiggy.png";
import SubWayLogo from "../../resources/subway.png";
import ZomatoLogo from "../../resources/zomato.png";

const getIcon = (row) => {
  const { metric = "", type = "" } = row;
  if (type === "swiggy") {
    return <img src={SwiggyLogo} height={14} />;
  } else if (type === "zomato") {
    return <img src={ZomatoLogo} height={10} />;
  }

  return <img src={SubWayLogo} height={10} />;
};

export const getScoreCardsHeader = (data = [], sectionName) => {
  if (!data || data.length === 0) return [];

  // First 1 fixed columns
  const fixedCols = [
    {
      label: "Metric",
      id: "metric",
      headPadding: "5px",
      width: 300,
      background: "#bdd7ee",
      freeze: true,
      render: (row) => {
        return (
          <Box
            sx={{
              display: "flex",
              minWidth: "200px",
              gap: "15px",
              alignItems: "center",
              width: "220px",
            }}
          >
            {getIcon(row)}
            <span>{row?.metric}</span>
          </Box>
        );
      },
    },
  ];

  const firstRow =
    data?.reduce((maxObj, currentObj) => {
      return currentObj.data.length > (maxObj?.data?.length || 0)
        ? currentObj
        : maxObj;
    }, null) || data[0];

  const dynamicCols = [];

  if (firstRow.data && Array.isArray(firstRow.data)) {
    firstRow.data.forEach((item) => {
      dynamicCols.push({
        label: item.key,
        id: item.key,
        background: "#bdd7ee",
        width: 100,
        render: (row) => {
          const value = row[item.key] ?? "-";
          const isComparison = item.key.startsWith("v/s");
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                minWidth: "130px",
              }}
            >
              <span style={{ color: isComparison ? "blue" : "inherit" }}>
                {value}
              </span>
            </Box>
          );
        },
      });
    });
  }

  return [...fixedCols, ...dynamicCols];
};

// helper.js
export const getTrendsHeader = (data = [], sectionName) => {
  if (!data || data.length === 0) return [];

  // First 3 fixed columns
  const fixedCols = [
    {
      label: "Type",
      id: "cohort",
      width: 150,
      freeze: true,
      background: "#bdd7ee",
      headPadding: "5px",
      render: (data) => {
        return (
          <Box
            sx={{
              minWidth: "150px",

              display: "flex",
            }}
          >
            {data?.cohort}
          </Box>
        );
      },
    },
    {
      label: "Particular",
      id: "particulars",
      width: 180,
      freeze: true,
      background: "#bdd7ee",
      headPadding: "5px",
      render: (data) => {
        return (
          <Box
            sx={{
              minWidth: "180px",

              display: "flex",
            }}
          >
            {data?.particular}
          </Box>
        );
      },
    },
    {
      label: "Metric",
      id: "metric",
      width: 180,
      freeze: true,
      background: "#bdd7ee",
      headPadding: "5px",
      render: (data) => {
        return (
          <Box
            sx={{
              display: "flex",
              minWidth: "200px",
              gap: "15px",
              alignItems: "center",
              width: "180px",
            }}
          >
            {getIcon(data)}
            {data?.metric}
          </Box>
        );
      },
    },
  ];

  // Find dynamic columns from the row with the most data
  const firstRow =
    data?.reduce((maxObj, currentObj) => {
      return currentObj.data.length > (maxObj?.data?.length || 0)
        ? currentObj
        : maxObj;
    }, null) || data[0];

  const dynamicCols = [];

  if (firstRow.data && Array.isArray(firstRow.data)) {
    firstRow.data.forEach((item) => {
      dynamicCols.push({
        label: item.key,
        id: item.key,
        background: "#bdd7ee",
        render: (row) => {
          const value = row[item.key] ?? "-";
          const isComparison = item.key.startsWith("v/s");

          // Find reference value from "All India" row with same metric AND type
          let referenceValue = undefined;
          const refRow = data.find(
            (r) =>
              r.cohort === "All India" &&
              r.metric === row.metric &&
              r.type === row.type
          );
          if (refRow && refRow.data) {
            const refItem = refRow.data.find((d) => d.key === item.key);
            referenceValue = refItem ? refItem.value : undefined;
          }

          // Only compare if both are numbers
          const actualValue = parseFloat(value);
          const actualReferenceValue = parseFloat(referenceValue);

          const isLess =
            !isNaN(actualValue) &&
            !isNaN(actualReferenceValue) &&
            actualValue < actualReferenceValue;
          const isGreater =
            !isNaN(actualValue) &&
            !isNaN(actualReferenceValue) &&
            actualValue > actualReferenceValue;

          const reverseMetrics = [
            "KPT",
            "RDC",
            "IGCC",
            "Detractors /1K orders",
            "KPT 10+ min orders",
          ];
          const isReverse = reverseMetrics.some((metric) =>
            refRow?.metric?.includes(metric)
          );
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                minWidth: "130px",
                background:
                  refRow?.metric !== "Store Count" &&
                  (isReverse
                    ? isLess
                      ? "#ebfceb"
                      : isGreater
                      ? "#ffebeb"
                      : undefined
                    : isLess
                    ? "#ffebeb"
                    : isGreater
                    ? "#ebfceb"
                    : undefined),
              }}
              borderRadius="4px"
            >
              <span style={{ color: isComparison ? "blue" : "inherit" }}>
                {value}
              </span>
            </Box>
          );
        },
      });
    });
  }

  return [...fixedCols, ...dynamicCols];
};

export const COHORT_KEYS = [
  "Overall Company",
  "Overall Company LFL",
  "Overall Company LFL non-split",
  "FOFO",
  "FOFO excl. airport",
  "FOFO LFL",
  "FOFO LFL non-split",
  "COCO",
  "COCO LFL",
  "COCO LFL non-split",
  "COCO Cat-1 / FY23",
  "COCO Cat-2 / FY24",
  "COCO Cat-3 / FY25",
  "COCO Cat-3 / FY25 wo Amex",
  "COCO Cat-4 / FY26",
  "COCO Built",
  "COCO Built LFL",
  "COCO Built LFL non-split",
  "COCO Built Cat-1 / FY23",
  "COCO Built Cat-2 / FY24",
  "COCO Built Cat-3 / FY25",
  "COCO Built Cat-3 / FY25 wo Amex",
  "COCO Built Cat-4 / FY26",
  "COCO Acquired",
  "COCO Acquired LFL",
  "COCO Acquired LFL non-split",
  "COCO Acquired Cat-1 / FY23",
  "COCO Acquired Cat-2 / FY24",
  "COCO Acquired Cat-3 / FY25",
  "COCO Acquired Cat-4 / FY26",
];
export const METRIC_KEYS = [
  "Store Count",
  "S-MFR",
  "S-RDC",
  "S-Serviceability",
  "S-Rating",
  "S-KPT",
  "S-Funnel M2C",
  "S-Funnel C2O",
  "S-Funnel M2O",
  // "SW-NPS",
  // "SW-Value For Money",
  "Z-MFR",
  "Z-RDC",
  "Z-Online avalibility %",
  "Z-Rating",
  "Z-KPT",
  "Z-KPT 10+ min orders",
  "Z-ORS",
  "NPS",
  "Value For Money",
];
export const MONTHLY_METRIC_KEYS = [
  "Detractors/1k orders",
  "ADS (INR)",
  "Dine-in ADS (INR)",
  "Delivery ADS (INR)",
  "ADT (bills / day)",
  "Dine-in ADT (bills / day)",
  "Delivery ADT (bills / day)",
  "APC (INR)",
  "Dine-in APC (INR)",
  "Delivery APC (INR)",
  "Revenue (INR)",
  "Dine-in Revenue (INR)",
  "Delivery Revenue (INR)",
];
export const SCOPE_FILTER_TYPES = [
  // { id: "All India", label: "All India", allowedRoles:[""] },
  { id: "type", label: "Type", allowedRoles: [] },
  { id: "priceCohort", label: "Cohort", allowedRoles: [] },
  { id: "region", label: "Region", allowedRoles: [] },
  { id: "tier", label: "Tier", allowedRoles: [] },
  { id: "circle", label: "Circle", allowedRoles: [] },
  { id: "city", label: "City", allowedRoles: [] },
  { id: "format", label: "Format", allowedRoles: [] },
  { id: "opsManager", label: "Ops Manager", allowedRoles: [] },
  { id: "am", label: "Area Manager", allowedRoles: [] },
  { id: "storeCode", label: "Store Code", allowedRoles: [] },
  { id: "storeOpeningDate", label: "Store Opening Date", allowedRoles: [] },

  // { id: "tier", label: "Tier", allowedRoles: [] },
];
export const REGIONS = [
  {
    label: "east",
    value: "east",
  },
  {
    label: "north",
    value: "north",
  },
  {
    label: "south",
    value: "south",
  },
  {
    label: "west",
    value: "west",
  },
];
export const CIRCLE = [
  {
    label: "AP&TS",
    value: "AP&TS",
  },
  {
    label: "Bangalore",
    value: "Bangalore",
  },
  {
    label: "Bihar, Jharkhand & Orissa",
    value: "Bihar, Jharkhand & Orissa",
  },
  {
    label: "Gujarat, MP & CG",
    value: "Gujarat, MP & CG",
  },
  {
    label: "Mumbai",
    value: "Mumbai",
  },
  {
    label: "NCR",
    value: "NCR",
  },
  {
    label: "North Zone",
    value: "North Zone",
  },
  {
    label: "Punjab",
    value: "Punjab",
  },
  {
    label: "ROK",
    value: "ROK",
  },
  {
    label: "ROK and Goa",
    value: "ROK and Goa",
  },
  {
    label: "Raj & Har",
    value: "Raj & Har",
  },
  {
    label: "RoMH",
    value: "RoMH",
  },
  {
    label: "RoMH & Goa",
    value: "RoMH & Goa",
  },
  {
    label: "TN&K",
    value: "TN&K",
  },
  {
    label: "Up&UK",
    value: "Up&UK",
  },
  {
    label: "WB & NE",
    value: "WB & NE",
  },
];
export const getFiltersByRole = () => {};
